export const API_BASE_URL =
  "https://o8a4f8zsn1.execute-api.us-east-1.amazonaws.com/dev";

export const BGG_API_URL = "https://boardgamegeek.com/xmlapi2/";
export const SEARCH_PLACEHOLDER = "search for map/designer...";
export const MAP_IMAGE_BUCKET_URL = "https://aos-map-images.s3.amazonaws.com";
export const LOCAL_IMAGE_PATH = "../assets/aosbox.png";
